import { render } from "./ItemsTable.vue?vue&type=template&id=44a14b5e&scoped=true"
import script from "./ItemsTable.vue?vue&type=script&lang=js"
export * from "./ItemsTable.vue?vue&type=script&lang=js"

import "./ItemsTable.vue?vue&type=style&index=0&id=44a14b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a14b5e"]])

export default __exports__